import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    spacer: {
        flex: '1 1 auto',
    },
    highlight: {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85)
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },

})

class DataToolbar extends React.Component {
    render() {
        const { title, numSelected, classes, children, inset } = this.props;
        return (<Toolbar className={classNames(classes.root, { [classes.highlight]: numSelected > 0, })} disableGutters={!inset}>
                    <div className={classes.title}>
                    {
                        numSelected > 0 
                        ? (
                            <Typography color="inherit" variant="subheading">
                                {numSelected} selected
                            </Typography>
                        ) 
                        : (
                            <Typography variant="title" id="tableTitle">
                                {title}
                            </Typography>
                        )
                    }
                    </div>
                    <div className={classes.spacer} />
                    <div className={classes.actions}>
                        {children}
                    </div>
                </Toolbar>
        )
    }
}
DataToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
}
export default withStyles(styles, { withTheme: true })(DataToolbar);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/DataTables/DataToolbar.js